import SaleUtils from '@/services/SaleUtils'
import { required } from '@/services/validations'
import ProductPricesHeaders from './headers'
// Fields to Comercial Information
export default [
    {
        //comercial fields[0] - Precio Costo
        name: 'cost_price',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Precio Costo $',
            rules: [],
            suffix: '',
            //   prefix : '$',
        },
        trigger: ctx => {
            //set margin value

            ctx.value.branch_office_selected.map(branch => {
                if (ctx.value.cost_price) {
                    branch.cost_price = ctx.value.cost_price
                    branch.gains_margin = SaleUtils.getNewMargin(
                        branch.sale_price,
                        ctx.value.cost_price
                    )
                }
            })
        },
    },
    {
        //comercial fields[1] - Precio Venta
        name: 'sale_price',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Precio Venta $',
            rules: [],
            suffix: '',
        },
        trigger: ctx => {
            //set net price
            // ctx.value.net_price = SaleUtils.getNetPrice(ctx.value.sale_price)
            // //set margin value
            // if(ctx.value.sale_price && ctx.value.cost_price  ){
            //   ctx.value.gains_margin = SaleUtils.getNewMargin(ctx.value.sale_price, ctx.value.cost_price)
            // }
            ctx.value.branch_office_selected.map(branch => {
                if (ctx.value.sale_price) {
                    branch.sale_price = ctx.value.sale_price
                    branch.gains_margin = SaleUtils.getNewMargin(
                        ctx.value.sale_price,
                        branch.cost_price
                    )
                }
                // if(ctx.value.sale_price && ctx.value.cost_price  ){
                //     branch.gains_margin = SaleUtils.getNewMargin(branch.sale_price, ctx.value.cost_price)
                //   }
            })
        },
    },
    // {
    //     //comercial fields[2] - Margen
    //     name: 'gains_margin',
    //     type: 'text-field',
    //     flex: {
    //       sm6: true,
    //       lg4: true,
    //     },
    //     props: {
    //       label: 'Margen',
    //       suffix: '%',
    //       readonly: true,
    //     },
    //     rules: [],
    //     trigger: (ctx)=>{
    //         //set net price
    //         // ctx.value.net_price = SaleUtils.getNetPrice(ctx.value.sale_price)
    //         // //set margin value
    //         // alert('jere')
    //         // ctx.value.branch_office_selected.map(branch=>{

    //         //     if(ctx.value.gains_margin){
    //         //       branch.gains_margin = ctx.value.gains_margin
    //         //     }

    //         // })

    //       }

    // },
    {
        props: { title: '' },
        type: 'section-field',
        flex: {
            'mb-3': true,
            xs12: true,
        },
    },
    {
        //comercial fields[4] - Producto Vendible
        name: 'is_salable',
        type: 'checkbox',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Producto Vendible',
            'false-value': false,
        },
        value: false,
    },
    {
        //comercial fields[5] - Producto libre de impuestos
        name: 'is_tax_free',
        type: 'checkbox',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Producto Libre de Impuesto',
        },
        value: false,
    },
    {
        //comercial fields[6] - Producto consumo interno
        name: 'is_consumable',
        type: 'checkbox',
        props: {
            label: 'Producto Consumo Interno',
            'false-value': false,
        },
        value: false,
    },
    {
        props: { title: 'Precios por sucursal' },
        type: 'section-field',
        flex: {
            'mb-3': true,
            xs12: true,
        },
    },
    {
        name: 'branch_office_selected',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: ProductPricesHeaders,
            noActions: true,
            noDataText: 'Sin sucursales.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,

            showNativePagination: true,
            //showPicker: true,
            style: {
                //margin: "0 -24px"
            },
            toolbarTitle: 'Detalle del stock en las diferentes sucursales',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
        },
    },
]
